import { useCallback, useState } from 'react';

export type ObjectDebtCurrency = 'base' | 'local';

const storageKey = (objectId: number) => `objectAnalyticsDebtCurrency:${objectId}`;

export const readObjectDebtCurrency = (objectId: number): ObjectDebtCurrency => {
    if (objectId <= 0) return 'base';
    try {
        return window.localStorage.getItem(storageKey(objectId)) === 'local' ? 'local' : 'base';
    } catch {
        return 'base';
    }
};

export const writeObjectDebtCurrency = (objectId: number, currency: ObjectDebtCurrency): void => {
    if (objectId <= 0) return;
    try {
        window.localStorage.setItem(storageKey(objectId), currency);
    } catch {
        // ignore quota / private mode
    }
};

export const useObjectDebtCurrency = (objectId: number) => {
    const [state, setState] = useState(() => ({
        objectId,
        currency: readObjectDebtCurrency(objectId),
    }));

    const currency = state.objectId === objectId ? state.currency : readObjectDebtCurrency(objectId);

    const toggle = useCallback(() => {
        if (objectId <= 0) return;
        const next: ObjectDebtCurrency = currency === 'local' ? 'base' : 'local';
        writeObjectDebtCurrency(objectId, next);
        setState({ objectId, currency: next });
    }, [objectId, currency]);

    return { currency, toggle };
};
